<template>
    <auto-line-chart ref="lineChart"
                     v-bind="$attrs"
                     :query-api="queryApi"
                     :query-body="queryBody"
                     :data-formatter="dataFormatter">
        <slot></slot>
    </auto-line-chart>
</template>

<script>
import AutoLineChart from "@/components/LayoutMaps/openLayers/stuff/AutoLineChart";
import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";

export default {
    name: "ComputedLineChart",
    mixins: [emCommonUtilMixin],
    components: {AutoLineChart},
    props: {
        nodeIds: {
            type: Array,
            default: () => []
        },
        titleMap: Map,
    },
    computed: {
        queryApi() {
            return process.env.VUE_APP_EM_OPCCLIENT_URL + "/emOpcUaResource/computedRecordByIds";
        },
        queryBody() {
            let query = this.deepCopyObj(this.$store.state.customizedDiagram.computedHistoryQuery);
            if (!query) {
                query = {
                    startOffset: -5,
                    unit: 'MINUTES',
                }
            }
            query.nodeIds = this.nodeIds;
            return query;
        }
    },
    methods: {
        dataFormatter(response) {
            let result = {};
            for (let nodeId in response.data) {
                let arr = response.data[nodeId];
                if (arr) {
                    let tempList = [];
                    for (let item of arr) {
                        let value = Number.parseFloat(`${item.value}`).toFixed(2);
                        tempList.push({
                            name: item.time,
                            value: [item.time, value]
                        });
                    }
                    let title = nodeId;
                    if (this.titleMap && this.titleMap.has(nodeId)) {
                        title = this.titleMap.get(nodeId);
                    }
                    result[title] = tempList;
                }
            }
            return result;
        },

        resizeChart() {
            this.$refs.lineChart.resizeChart();
        },
    },
}
</script>

<style scoped>

</style>
